// import { Container } from '@components';
import { GetCoverStoriesQuery } from '@graphqlTypes';

// Context
import { useCoverStory } from '@/providers/CoverStoryContext';

// Components
import Game from './Game/Game';
import CoverStoryEndScreen from './EndScreen/CoverStoryEndScreen';

// Styles
import styles from './CoverStory.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

// Debug
import { useDebug } from "@/utils/useDebugLog";

interface CoverStoryProps {
  title: string;
  options: CoverStoryOptions;
  gameData: CoverStoryGameData;
  coverStories: GetCoverStoriesQuery['coverStories'];
  pageUri?: string;
}

export default function CoverStory({ coverStories, gameData, options, title, pageUri }: CoverStoryProps) {
  const { log } = useDebug({ name: 'CoverStory', bgColor: '#044BD9', textColor: 'white', enabled: false });
  const { gameState } = useCoverStory();

  log({ options, gameData, coverStories, gameState });

  return (
    <section className={cx(["cover-story"])}>

      {/* Gabe's: Game */}
      <Game key={gameData.gameNumber} title={title} options={options} gameData={gameData} />

      {/* End Screen - Only show when game is over */}
      {(gameState === 'won' || gameState === 'lost') && (
        <CoverStoryEndScreen options={options} coverStories={coverStories} gameData={gameData} pageUri={pageUri} />
      )}

    </section>
  );
}
